import {
  Autocomplete,
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Country } from "country-state-city";
import { AddBussinessDeveloper, uploadFile } from "../../DAL/create";
import { useNavigate, useParams } from "react-router-dom";
import { GetSingleBubbleImages } from "../../DAL/fetch";
import { enqueueSnackbar } from "notistack";

export const AddBussinessDevelopers = () => {
    const navigate = useNavigate();
    const [error,setError]=useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [inputs, setInputs] = useState({
    picture: "",
    name: "",
    country: "",
    email: "",
    phone: "",
    address: "",
    userName: "",
    password: "",
    bankName: "",
    bankAccountName: "",
    whatsapp: "",
  });


  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    const resp = await uploadFile(formData);
    setPreviewImage(URL.createObjectURL(e.target.files[0]))
    setInputs((prev) => ({ ...prev, picture: resp?.data?.url }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("picture", inputs?.picture);
    formData.append("name", inputs?.name);
    formData.append("userName", inputs?.userName);
    formData.append("email", inputs?.email);
    formData.append("phone", inputs?.phone);
    formData.append("address", inputs?.address);
    formData.append("password", inputs?.password);
    formData.append("bankName", inputs?.bankName);
    formData.append("bankAccountName", inputs?.bankAccountName);
    formData.append("whatsapp", inputs?.whatsapp);

    const resp = await AddBussinessDeveloper(formData);
    if (resp.status == 201) {
      enqueueSnackbar("Data added successfully", { variant: "success" });
      navigate("/bussiness-developers")
    } else {
      enqueueSnackbar("Error while added data", { variant: "error" });
    }
  };

 
  return (
    <>
      <div className="mainDiv">
        <Typography variant="h6">Add Bussiness Developers</Typography>
        <Box>
          <Grid container spacing={2}>
            <Grid item lg={6}>
              <TextField
                label="Name"
                onChange={handleChange}
                name="name"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Email"
                name="email"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="User Name"
                name="userName"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Address"
                name="address"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Phone"
                name="phone"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Bank Name"
                name="bankName"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Account Nnmber"
                name="bankAccountName"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Whatsapp"
                name="whatsapp"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <TextField
                onChange={handleChange}
                label="Password"
                name="password"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item lg={6}>
              <Autocomplete
                size="small"
                options={Country.getAllCountries()}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} label="Select Country" />
                )}
                value={selectedCountry}
                onChange={(event, newValue) => {
                  setSelectedCountry(newValue);
                }}
              />
            </Grid>
            <Grid item lg={12} sx={{ marginTop: "10px" }}>
              <Grid container spacing={2}>
                <Grid item lg={4}>
                  <Typography>Upload Image *</Typography>
                  <FormHelperText>Image Size(200X100)</FormHelperText>
                </Grid>
                <Grid item lg={2} sx={{ textAlign: "center" }}>
                  <img
                    src={previewImage}
                    alt=""
                    style={{ width: "80%", height: "70px" }}
                  />
                </Grid>
                <Grid item lg={6} sx={{ textAlign: "end" }}>
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="upload-button"
                    type="file"
                    onChange={handleImageUpload}
                  />
                  <label htmlFor="upload-button">
                    <Button
                      variant="contained"
                      component="span"
                      sx={{
                        background:
                          "linear-gradient(to right, #5301d7, #008eca)",
                        color: "white",
                      }}
                    >
                      Upload
                    </Button>
                  </label>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} sx={{ textAlign: "end" }}>
              <Button
                variant="contained"
                sx={{
                  background: "linear-gradient(to right, #5301d7, #008eca)",
                  color: "white",
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};
